import { createRegularCatalogAdapter } from "../catalog/adapter";
import { giftCardAdapter } from "../gift-cards/adapter";
import { membershipAdapter } from "../memberships/adapter";
import { packageAdapter } from "../packages/adapter";

import { ItemType } from "@/types/enums/item-type";
import { ShopCartLine } from "@/types/shop";

import { ShopItemAdapter } from "./types";

/**
 * Registry of per-type data adapters. Adding a future type (MEMBERSHIP,
 * PRODUCT, TICKETS) is a one-line registration here plus a sibling module
 * under `shop/<type>/` exposing the adapter.
 */
const adapters: Partial<Record<ItemType, ShopItemAdapter<ShopCartLine>>> = {
  [ItemType.GIFT_CARD]: giftCardAdapter as ShopItemAdapter<ShopCartLine>,
  [ItemType.PACKAGE]: packageAdapter as ShopItemAdapter<ShopCartLine>,
  [ItemType.MEMBERSHIP]: membershipAdapter as ShopItemAdapter<ShopCartLine>,
  [ItemType.SERVICE]: createRegularCatalogAdapter(
    ItemType.SERVICE,
  ) as ShopItemAdapter<ShopCartLine>,
  [ItemType.PRODUCT]: createRegularCatalogAdapter(
    ItemType.PRODUCT,
  ) as ShopItemAdapter<ShopCartLine>,
  [ItemType.MEDICATION]: createRegularCatalogAdapter(
    ItemType.MEDICATION,
  ) as ShopItemAdapter<ShopCartLine>,
};

export function getAdapter(
  type: ItemType,
): ShopItemAdapter<ShopCartLine> | null {
  return adapters[type] ?? null;
}

export type { ShopItemAdapter } from "./types";
